import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'
const { createNewAppointment } = importer('APIs/appointments', null)
const AppointmentsActions = importer('Stores/Appointments/Actions')
const { tokens } = importer('Stores/Users/Select', null)
export default function * main ({ appointment }) {
  try {
    const _tokens = yield select(tokens)
    const { token_type, id_token } = _tokens
    const token = `${token_type} ${id_token}`
    yield put(AppointmentsActions.createNewAppointmentLoading())
    const res = yield createNewAppointment(appointment, token)
    /* Note: with PD-3036/PD-6030 API will be returning status 200 when the business logic fails,
    example: Donation Center is closed on this day OR You already have an appointment scheduled for this day.*/
    // if the response have error code then call the appointment failure
    if(res.data?.code){
      const errorObj={
        response:{
          data: res.data
        }
      }
      yield put(AppointmentsActions.createNewAppointmentFailure(errorObj))
    } else{
      yield put(AppointmentsActions.createNewAppointmentSuccess(res))
    }
  } catch (error) {
    yield put(AppointmentsActions.createNewAppointmentFailure(error))
  }
}
